import React, { useContext, useEffect, useState } from "react";
import "./Filter_By_Offcanvas.css";
import { Accordion, Form, Offcanvas } from "react-bootstrap";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Slider } from "@mui/material";
import White_Btn from "../common_btn/white_btn/White_Btn";
import Dark_Gray_Btn from "../common_btn/dark_gray_btn/Dark_Gray_Btn";
import { useNavigate, useLocation } from "react-router-dom";

import {
  CustomisableProducts,
  occasion,
} from "../../../utils/apis/Home/Homeapi";
import { Brands, Material } from "../../../utils/apis/master/Master";
import { Website_Type } from "../../../utils/common";
import { Context } from "../../../utils/context";
import { luxuryCategory } from "../../../utils/luxuryapis/Home/Homeapi";

const Filter_By_Offcanvas = ({ show, handleClose,showOccasion }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isOnProductsPage = location.pathname === "/luxury/products";

  const {
    filters,
    updateFilter,
    resetFilters,
    toggleArrayFilter,
    applyFilters,
    cancelFilters,
  } = useContext(Context);

  const [categories, setCategories] = useState([]);
  const [customisableProduct, setCustomisableProduct] = useState({});
  const [allMaterial, setAllMaterial] = useState([]);
  const [occasions, setOccasions] = useState([]);
  const [activeKey, setActiveKey] = useState("parent-0");

  const marks = [
    { value: filters?.price_min, label: `₹ ${filters?.price_min}` },
    { value: filters?.price_max, label: `₹ ${filters?.price_max}` },
  ];

  const getAllLuxuryCategory = async () => {
    const res = await luxuryCategory();
    if (res?.success) {
      setCategories([{ id: "all", name: "All Products" }, ...res.data]);
    }
  };

  const getAllCustomisableProducts = async () => {
    const res = await CustomisableProducts(Website_Type.Luxury);
    if (res?.success) setCustomisableProduct(res.data);
  };

  const getAllMaterials = async () => {
    const res = await Material(Website_Type.Luxury);
    if (res?.success) setAllMaterial(res.data);
  };

  const getOccasions = async () => {
    const res = await occasion(Website_Type.Luxury);
    if (res?.success) setOccasions(res.data);
  };

  const [brand, setBrand] = useState();
  const getAllBrand = async () => {
    const res = await Brands(Website_Type.Luxury);
    if (res?.success) {
      setBrand(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getAllLuxuryCategory();
    getAllCustomisableProducts();
    getAllMaterials();
    getOccasions();
    getAllBrand();
  }, []);

  const handleApply = () => {
    applyFilters();
    handleClose();
    if (!isOnProductsPage) navigate("/luxury/products");
  };

  const handleCancel = () => {
    resetFilters();
    setActiveKey("parent-0")
    handleClose();
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      className="Filter_By_Offcanvas"
    >
      <Offcanvas.Header>
        <Offcanvas.Title>Filter By</Offcanvas.Title>
        <div className="close_holder" onClick={handleClose}>
          <img src="/assest/luxury_images/other/cancel.png" className="close_img" />
        </div>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <div className="filter_div">

          {/* ── Customisable ── */}
          <div className="input_container">
            <Form.Check
              type="checkbox"
              label={`Customisable (${customisableProduct?.count || 0})`}
              checked={filters.customisable}
              onChange={(e) => updateFilter("customisable", e.target.checked)}
            />
          </div>

          {/* ── Category ── */}
          <div className="input_container">
            <p className="section_title">Products by Category</p>
            <div className="sidebar_main">
              <div className="sidebar_list">
                <Accordion
                  flush
                  activeKey={activeKey}
                  onSelect={(key) => setActiveKey(key)}
                  className="orange_accordion"
                >
                  {categories?.map((item, index) => (
                    <Accordion.Item eventKey={`parent-${index}`} key={index}>
                      <Accordion.Header
                        className={activeKey === `parent-${index}` ? "active" : ""}
                        onClick={() => updateFilter("category_id", item.id)}
                      >
                        <div
                          className={`menu_item ${filters.category_id === item.id ? "selected" : ""
                            }`}
                        >
                          {item?.name}
                        </div>
                        <div className="icon_holder">
                          <FontAwesomeIcon icon={faAngleRight} className="inner_icon" />
                        </div>
                      </Accordion.Header>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>

          {/* ── Price Range ── */}
          <div className="input_container">
            <p className="section_title">Price Range</p>
            <div className="slider_div">
              <Slider
                min={0}
                max={150000}
                value={[filters.price_min, filters.price_max]}
                marks={marks}
                step={500}
                valueLabelDisplay="auto"
                valueLabelFormat={(value) => `₹ ${value.toLocaleString()}`}
                onChange={(e, newValue) => {
                  updateFilter("price_min", newValue[0]);
                  updateFilter("price_max", newValue[1]);
                }}
              />
            </div>
          </div>

          {/* ── Quantity ── */}
          <div className="input_container">
            <p className="section_title">Quantity</p>
            <div className="qty_holder">
              <Form.Control
                type="number"
                placeholder="Enter Quantity"
                value={filters?.quantity || ""}
                min={0}
                onKeyDown={(e) => {
                  if (e.key === "-" || e.key === "e") {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => updateFilter("quantity", e.target.value)}
              />
              <div className="checkbox_holder">
                <Form.Check
                  type="checkbox"
                  label="No Minimum Quantity"
                  checked={filters.quantity === "0"}
                  onChange={(e) => updateFilter("quantity", e.target.checked ? "0" : "")}
                />
              </div>
            </div>
          </div>

          {/* ── Occasion + Material — MULTI SELECT ── */}
          <div className="input_container">
            <Accordion className="info_accordion" defaultActiveKey={showOccasion ? "5" : null}>

              {/* Brand — multi select ✅ */}
              <Accordion.Item eventKey="4">
                <Accordion.Header>
                  Brands
                  {/* Show count badge when selections exist */}
                  {filters.brand_ids?.length > 0 && (
                    <span className="ms-2 badge bg-primary">
                      {filters.brand_ids.length}
                    </span>
                  )}
                </Accordion.Header>
                <Accordion.Body>
                  <div className="accordBodycontent">
                    {brand?.map((val) => (
                      <p
                        key={val.id}
                        className={
                          filters.brand_ids?.includes(val.id) ? "active" : ""
                        }
                        onClick={() => toggleArrayFilter("brand_ids", val.id)}
                      >
                        <Form.Check
                          type="checkbox"
                          readOnly
                          checked={filters.brand_ids?.includes(val.id)}
                        />{" "}
                        {val?.name}
                      </p>
                    ))}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5">
                <Accordion.Header>
                  Occasion
                  {/* Show count badge when selections exist */}
                  {filters.occasion_ids?.length > 0 && (
                    <span className="ms-2 badge bg-primary">
                      {filters.occasion_ids.length}
                    </span>
                  )}
                </Accordion.Header>
                <Accordion.Body>
                  <div className="accordBodycontent">
                    {occasions?.map((val) => (
                      <p
                        key={val.id}
                        className={
                          filters.occasion_ids?.includes(val.id) ? "active" : ""
                        }
                        onClick={() => toggleArrayFilter("occasion_ids", val.id)}
                      >
                        <Form.Check
                          type="checkbox"
                          readOnly
                          checked={filters.occasion_ids?.includes(val.id)}
                        />{" "}
                        {val?.name}
                      </p>
                    ))}
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              {/* Material — multi select ✅ */}
              <Accordion.Item eventKey="6">
                <Accordion.Header>
                  Material
                  {filters.material_ids?.length > 0 && (
                    <span className="ms-2 badge bg-primary">
                      {filters.material_ids.length}
                    </span>
                  )}
                </Accordion.Header>
                <Accordion.Body>
                  <div className="accordBodycontent">
                    {allMaterial?.map((val) => (
                      <p
                        key={val.id}
                        className={
                          filters.material_ids?.includes(val.id) ? "active" : ""
                        }
                        onClick={() => toggleArrayFilter("material_ids", val.id)}
                      >
                        <Form.Check
                          type="checkbox"
                          readOnly
                          checked={filters.material_ids?.includes(val.id)}
                        />{" "}
                        {val?.name}
                      </p>
                    ))}
                  </div>
                </Accordion.Body>
              </Accordion.Item>

            </Accordion>
          </div>

        </div>
      </Offcanvas.Body>

      <Offcanvas.Header className="bottom_header">
        <div className="btns_holder">
          <White_Btn btnText="Reset" onClick={handleCancel} />
          <Dark_Gray_Btn btnText="Apply" onClick={handleApply} />
        </div>
      </Offcanvas.Header>
    </Offcanvas>
  );
};

export default Filter_By_Offcanvas;